"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var styles = __importStar(require("../../Nursing.module.css"));
var FinancialHeader = (function (_super) {
    __extends(FinancialHeader, _super);
    function FinancialHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FinancialHeader.prototype.render = function () {
        return (React.createElement("div", { className: styles.rowSectionContainer },
            React.createElement("p", { className: styles.rowItemTitle + " " + styles.onlyBottom }, "FINANCIAL"),
            React.createElement("p", null, "The cost of attendance is as follows, subject to the terms and refund policy stated on this document.")));
    };
    FinancialHeader = __decorate([
        mobx_react_1.observer
    ], FinancialHeader);
    return FinancialHeader;
}(react_1.Component));
exports.FinancialHeader = FinancialHeader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmluYW5jaWFsSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9FbnJvbGxtZW50QWdyZWVtZW50L051cnNpbmcvcGFydHMvZmluYW5jaWFsL0ZpbmFuY2lhbEhlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFDL0IseUNBQW1DO0FBQ25DLCtEQUFrRDtBQUdsRDtJQUFxQyxtQ0FBUztJQUE5Qzs7SUFZQSxDQUFDO0lBWFUsZ0NBQU0sR0FBYjtRQUNJLE9BQU8sQ0FDSCw2QkFBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLG1CQUFtQjtZQUN0QywyQkFBRyxTQUFTLEVBQUssTUFBTSxDQUFDLFlBQVksU0FBSSxNQUFNLENBQUMsVUFBWSxnQkFBZTtZQUMxRSx1SUFHSSxDQUNGLENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFYUSxlQUFlO1FBRDNCLHFCQUFRO09BQ0ksZUFBZSxDQVkzQjtJQUFELHNCQUFDO0NBQUEsQUFaRCxDQUFxQyxpQkFBUyxHQVk3QztBQVpZLDBDQUFlIn0=